export interface Access {
  id: string;
  email: string;
  roles: AccessRole[];
  me: boolean;
}

export interface AccessCreateRequest {
  email: string;
  roles: AccessRole[];
  projectId: string;
}

export interface AccessUpdateRequest {
  roles: AccessRole[];
}

export enum AccessRole {
  Manager = "Manager",
  DataCollector = "DataCollector",
  Coder = "Coder",
  Reviewer = "Reviewer",
  ResultsManager = "ResultsManager",
}
